import { targetClients } from '../../data/company';
import SectionHeading from '../ui/SectionHeading';
import AnimatedSection from '../ui/AnimatedSection';
import { getIcon } from '../../lib/icons';
import { motion } from 'framer-motion';

export default function TargetClients() {
  return (
    <section className="section-padding bg-white">
      <div className="container-custom">
        <AnimatedSection>
          <SectionHeading
            subtitle="Who We Serve"
            title="Building for Every Client"
            description="We tailor our services to meet the unique needs and expectations of diverse client segments."
          />
        </AnimatedSection>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mt-12">
          {targetClients.map((client, index) => {
            const IconComponent = getIcon(client.icon);

            return (
              <AnimatedSection key={index} delay={index * 0.1}>
                <motion.div
                  whileHover={{ y: -4 }}
                  className="p-8 bg-gradient-to-br from-charcoal-50 to-white border border-charcoal-100 rounded-2xl hover:shadow-lg transition-all text-center"
                >
                  <div className="p-4 bg-primary-100 rounded-2xl w-fit mx-auto mb-6">
                    <IconComponent className="w-8 h-8 text-primary-600" />
                  </div>
                  <h3 className="font-semibold text-xl text-charcoal-900 mb-3">
                    {client.title}
                  </h3>
                  <p className="text-charcoal-600 text-sm leading-relaxed">
                    {client.description}
                  </p>
                </motion.div>
              </AnimatedSection>
            );
          })}
        </div>
      </div>
    </section>
  );
}
